export const scrollToElement = (refElement: React.RefObject<HTMLElement>): void => {
  if (refElement.current) {
    refElement.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
